export function getView(requirement) {
  return requirement.create_task && requirement.is_skippable
}
